var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-6xl mx-auto grid grid-cols-12 gap-6 mt-8 mb-20"},[_c('carga-tabs')],1)}
var staticRenderFns = []

export { render, staticRenderFns }